import { useCallback } from 'react';
import { formatGraphqlErrors } from 'utils/helpers';
import { get } from 'lodash';
import { useMutation } from '@apollo/client/react';
import {
  type MonthlyExpensesCategoryValueMutationVariables,
  MonthlyExpensesCategoryValueDocument,
} from 'graphql/generated/graphql';

const useCalculateMonthlyExpensesCategoryValue = () => {
  const [calculateMonthlyExpensesCategoryValue] = useMutation(MonthlyExpensesCategoryValueDocument);

  const handleCalculate = useCallback(
    async ({ categoryName, importanceValue }: MonthlyExpensesCategoryValueMutationVariables) => {
      try {
        const result = await calculateMonthlyExpensesCategoryValue({
          variables: { categoryName, importanceValue },
        });
        const category = get(result, 'data.monthlyExpensesCategoryValue');
        return category;
      } catch (error) {
        const e = formatGraphqlErrors(error);
        throw e;
      }
    },
    [calculateMonthlyExpensesCategoryValue],
  );

  return handleCalculate;
};

export default useCalculateMonthlyExpensesCategoryValue;
